import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function FAQs() {
  return (
    <div className="privacy">
      <div className="enlarge-text">
        <p><strong>FREQUENTLY ASKED QUESTIONS</strong></p>
        <p><strong>What materials are used?</strong></p>
        <p>
          Materials are listed on each product page. The current collection
          includes 925 sterling silver, selected gold-vermeil finishes, and the
          gemstones or pearls identified in the product details.
        </p>
        <p><strong>Will the item look exactly like the photograph?</strong></p>
        <p>
          Small variations in colour, texture, and natural stones may occur.
          Screen settings can also affect colour. Product images show the
          intended design from multiple angles.
        </p>
        <p><strong>How do I care for my jewellery?</strong></p>
        <p>
          Keep pieces dry and away from perfume, cosmetics, chlorine, and harsh
          cleaners. Store them separately and wipe gently with a soft cloth.
        </p>
        <p><strong>Where do you ship?</strong></p>
        <p>
          Available destinations, costs, and estimates are shown at checkout.
          See <Link to="/shipping">Shipping</Link> for more information.
        </p>
        <p><strong>Can I return an order?</strong></p>
        <p>
          Eligibility depends on item condition, hygiene restrictions, and the
          reason for return. Review the <Link to="/returns">Returns</Link> page
          before sending anything back.
        </p>
        <p><strong>How can I contact mefurvexo?</strong></p>
        <p>
          Email <a href="mailto:gear@mefurvexo.monster">gear@mefurvexo.monster</a>
          {" "}with your order number, if applicable.
        </p>
      </div>
    </div>
  );
}

export default FAQs;
